import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { TwilioVoiceIntegration } from '@/shared/types/integration';

import CardBase from '../../Components/CardBase';

/**
 * Relays live call transcripts to the Twilio Voice SDK client over
 * UserDefinedMessages. Twilio-only; advanced setting, off by default.
 */
const TranscriptRelay = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TwilioVoiceIntegration>();

  return (
    <CardBase title={t('integrations.twilio_voice_connect.transcript_relay_enabled.title')}>
      <FormField
        control={control}
        name="config.transcript_relay_enabled"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start justify-between gap-3">
            <div className="space-y-1">
              <FormLabel className="text-sm leading-none">
                {t('integrations.twilio_voice_connect.transcript_relay_enabled.label')}
              </FormLabel>
              <FormDescription>
                {t('integrations.twilio_voice_connect.transcript_relay_enabled.description')}
              </FormDescription>
            </div>
            <FormControl>
              <Switch checked={field.value ?? false} onCheckedChange={field.onChange} />
            </FormControl>
          </FormItem>
        )}
      />
    </CardBase>
  );
};

export default TranscriptRelay;
